import React from 'react';

const GradientExamples = () => {
    const containerStyle = {
        padding: '20px',
        fontFamily: 'sans-serif'
    };

    const headerStyle = {
        textAlign: 'center'
    };

    const examplesContainerStyle = {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '40px',
        justifyContent: 'center',
        marginTop: '20px'
    };

    // Example 1: Diagonal 6-Color Linear Gradient
    const diagonalGradientStyle = {
        width: '200px',
        height: '200px',
        background: 'linear-gradient(45deg, red 0%, orange 20%, yellow 40%, green 60%, blue 80%, purple 100%)',
        border: '1px solid #333'
    };

    // Example 2: Piecewise Gradient with Sharp Transitions
    const piecewiseGradientStyle = {
        width: '200px',
        height: '200px',
        background: 'linear-gradient(90deg, red 0%, red 25%, yellow 25%, yellow 50%, blue 50%, blue 75%, green 75%, green 100%)',
        border: '1px solid #333'
    };

    // Example 3: Radial Gradient
    const radialGradientStyle = {
        width: '200px',
        height: '200px',
        background: 'radial-gradient(circle, red 0%, orange 40%, yellow 60%, green 80%, blue 100%)',
        border: '1px solid #333'
    };

    // Example 4: Creative Conic Gradient
    // Conic gradients rotate colors around a central pivot, giving a dynamic look.
    const creativeGradientStyle = {
        width: '200px',
        height: '200px',
        background: 'conic-gradient(from 90deg at 50% 50%, red, yellow, lime, aqua, blue, magenta, red)',
        border: '1px solid #333'
    };

    return (
        <div style={containerStyle}>
            <h2 style={headerStyle}>CSS Gradient Examples in React</h2>
            <div style={examplesContainerStyle}>
                <div>
                    <h3>Diagonal 6-Color Gradient</h3>
                    <div style={diagonalGradientStyle}></div>
                </div>
                <div>
                    <h3>Piecewise Prominent Colors</h3>
                    <div style={piecewiseGradientStyle}></div>
                </div>
                <div>
                    <h3>Radial Gradient</h3>
                    <div style={radialGradientStyle}></div>
                </div>
                <div>
                    <h3>Creative Conic Gradient</h3>
                    <div style={creativeGradientStyle}></div>
                </div>
            </div>
        </div>
    );
};

export default GradientExamples;
